import React from "react";
import { Dropdown } from "semantic-ui-react";
import PropTypes from "prop-types";

/**
 * Current list of applicable themes.
 */
const themes = [
  {
    text: "Light",
    value: "light"
  },
  {
    text: "Dark",
    value: "dark"
  }
];

/**
 * ThemeSelection: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Dropdown component which lets the user select from a list
 * of themes.
 *
 * @param {*} props
 */
const ThemeSelection = props => (
  <Dropdown
    selection
    options={themes}
    onChange={props.onChange}
    value={props.currentTheme}
  />
);

ThemeSelection.propTypes = {
  /**
   * onChange: (event, sender) => ()
   * Fired when the selected theme in the dropdown has changed
   */
  onChange: PropTypes.func.isRequired,
  /**
   * currentTheme: String
   * Currently applied theme identifier
   */
  currentTheme: PropTypes.string.isRequired
};

export default ThemeSelection;



// WEBPACK FOOTER //
// ./src/modules/settings/ThemeSelection.js